export default __webpack_public_path__ + "static/media/devoxxLogo.bea2c549.png";